export default __webpack_public_path__ + "static/media/IMG4054.3aacd403.jpg";